import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { UnverifiedBadgeCounter } from "./UnverifiedBadgeCounter";

interface MissedBadgeCounterProps {
  unverifiedBadgeCount: number;
}

export function MissedBadgeCounter(props: MissedBadgeCounterProps) {
  const { unverifiedBadgeCount } = props;

  return (
    <>
      <Stack alignItems="center" spacing={1}>
        <Text
          variant="h1"
          color={(theme) =>
            unverifiedBadgeCount > 0 ? theme.palette.intent?.error.text : theme.palette.text.primary
          }
        >
          {unverifiedBadgeCount}
        </Text>
      </Stack>

      <UnverifiedBadgeCounter unverifiedBadgeCount={unverifiedBadgeCount} />
    </>
  );
}
